import React from 'react';

export const ContentCardWrapper = ({
    contentType,
    children,
    render = () => null,
}) => {
    const redirectContent =
        contentType === 'community-podcast' ||
        contentType === 'editorial-content';
    if (redirectContent) {
        return (
            <span className="feed-content-link">{render() || children}</span>
        );
    }

    return <>{render() || children}</>;
};
